import { ReactNode } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

interface Props {
  redirectPath?: any,
  isMaintenance?: any
  children?: ReactNode
  // any props that come into the component
}
/* @ts-ignore */
export const MaintenanceRoute: React.FC<{}> = ({ isMaintenance, redirectPath = '/maintenance', children }: Props) => {
  if (isMaintenance) {
    return <Navigate to={redirectPath} replace />;
  }
  return children ? children : <Outlet />;
};

// export const MaintenanceRoute = function ({ isMaintenance, redirectPath = '/maintenance', children }: Props): React.FC<Props> {
//   if (isMaintenance) {
//     return <Navigate to={redirectPath} replace /> as any;
//   }
//   return (children ? children : <Outlet />) as any;
// };